<template>
	<div id="canvas1">
		<ContentHeader>
			<div>
				<SubHeader
					:title="tituloDashboard"
					:subtitle="labelUltimoProcessamento"
				>
					<template #actions>
						<ButtonDropdown
							v-model="model.fzda_ds_descricao"
							data-testid="dropdown2-component"
							:label="$t('selectFarm')"
							color="trv-default"
							min-width="11rem"
							style="margin-left: auto !important; margin-right: 20px !important"
							semantic-class="mini"
							:options="fazenda"
						/>
						<ButtonDropdown
							v-model="model.ordemServicoId2"
							data-testid="dropdown2-component"
							:label="$t('serviceOrder')"
							color="trv-default"
							min-width="11rem"
							:disabled="model.fzda_ds_descricao ? false : true"
							style="margin-right: 20px !important"
							semantic-class="mini"
							:options="ordemServico"
						/>
						<Button
							data-testid="botao-active"
							style="margin-right: 20px !important"
							:label="$t('generateReport')"
							:loading="isLoading"
							:disabled="model.ordemServicoId2 ? false : true"
							color="trv-default"
							semantic-class="tiny"
							width-auto
							@click="exportPDF"
						/>
					</template>
				</SubHeader>
			</div>
			<div v-show="showCrud">
				<!-- <div style="display:flex;align-content: space-between;">
          <Card>
            <div>
              <h4>Fazenda: {{model.fzda_ds_descricao2}}</h4>
              <h4>Data de e Fim: {{model.orsv_dt_data_final}}</h4>
              <h4>Data de Ínicio: {{model.orsv_dt_data_inicial}}</h4>
              <h4>Estrato: {{model.estratoFlorestal}}</h4>

            </div>
          </Card>
          <div> </div>
          <Card>

            <div>

              <h4>Tipo de Ordem: {{model.tipoDeServico}}</h4>
              <h4>Data Final: {{model.orsv_dt_prazo_final}}</h4>
              <h4>Ordem de Serviço: {{model.orsv_ds_descricao}}</h4>

            </div>
          </Card>

        </div> -->

				<Card class="container__dashboard__contentbody__card">
					<CrudTable
						:headers="headersAtivos"
						:data="arrayrelatorioFiltrado"
						:table-configuration="tableConfiguration"
						:value-selected="valueSelected.menu"
					/>
				</Card>

				<div class="container__crud__pagination">
					<Pagination
						ref="ref__pagination"
						:quantity-per-page="quantityPerPage"
						:quantity-per-page-options="[10, 20, 30]"
						:total-records="modelsToBeShowedAndTotal.total"
						@setStartEnd="setStartEnd"
						@setQuantityPerPage="setQuantityPerPage"
					/>
				</div>

				<Card class="container__dashboard__contentbody__card">
					<CrudTable
						id="my-table"
						:headers="headersAtivosOS"
						:data="arrayOrdemFiltrado"
						:table-configuration="tableConfiguration"
						:value-selected="valueSelected.menu"
					/>
				</Card>

				<div class="container__crud__pagination">
					<Pagination
						ref="ref__pagination"
						:quantity-per-page="quantityPerPage"
						:quantity-per-page-options="[10, 20, 30]"
						:total-records="modelsToBeShowedAndTotal.total"
						@setStartEnd="setStartEnd"
						@setQuantityPerPage="setQuantityPerPage"
					/>
				</div>
			</div>
		</ContentHeader>
	</div>
</template>
<script type="text/javascript" src="libs/png_support/zlib.js"></script>
<script type="text/javascript" src="libs/png_support/png.js"></script>
<script type="text/javascript" src="jspdf.plugin.addimage.js"></script>
<script type="text/javascript" src="jspdf.plugin.png_support.js"></script>
<script type="text/javascript" src="jspdf.js"></script>
<script>
import { mapActions } from 'vuex'

import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

import Pagination from '../../../components/Pagination/Pagination'

import Button from '../../../components/Button/Button'
import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'
import { getAllFazendasComInventarioFlorestalDropdown } from '../../../services/requests/FazendaRequests'
import CrudTable from '../../../components/CrudTable/CrudTable'
import Card from '../../../components/Card/Card'
import { getAllMedicoesInventario } from '../../../services/requests/MedicoesInventarioRequests'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ButtonDropdown from '../../../components/ButtonDropdown/ButtonDropdown'
import SubHeader from '../../../components/SubHeader/SubHeader'
import axios from 'axios'
import {
	GetReportDropdownOrdemServico,
	GetReportOrdemServico,
	GetReportOrdemServicoCabecalho,
} from '../../../services/requests/RelatorioRequests'

import {
	getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId,
	getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId,
	getQuantidadeDeArvoresPorCategoriaByFazendaId,
	getProporcaoDeArvoresUteisByFazendaId,
	getProporcaoDeArvoresUteisGroupedByPlantioEqualsFazendaId,
	getDataUltimoProcessamentoByFazendaId,
} from '../../../services/requests/DashBoardRequests'

import { CoordenatesToGooglePattern } from '../../../utils/MapFunctions'

export default {
	computed: {
		headersAtivosOS() {
			const ativos = this.tableHeadersOS.filter((f) => this.headersSelecionadosOS.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		tableHeaders: {
			get() {
				return [
					{ key: 'fazenda', value: this.$t('farm'), isActive: true },
					{
						key: 'orsv_ds_descricao',
						value: this.$t('serviceOrder'),
						isActive: true,
					},
					{
						key: 'orsv_dt_data_inicial',
						value: this.$t('startDate'),
						isActive: false,
					},
					{
						key: 'orsv_dt_data_final',
						value: this.$t('finalDate'),
						isActive: true,
					},

					{
						key: 'orsv_dt_prazo_final',
						value: this.$t('deadline'),
						isActive: true,
					},
					{
						key: 'estratoFlorestal',
						value: this.$t('forestStratification'),
						isActive: true,
					},
				]
			},
			set(e) {
				this.headersSelecionados = e.map((m) => m.key)
			},
		},
		tableHeadersOS: {
			get() {
				return [
					{ key: 'codigo', value: this.$t('code'), isActive: true },
					{ key: 'nome', value: this.$t('name'), isActive: true },
					{ key: 'funcao', value: this.$t('function'), isActive: false },
					{ key: 'numeroDeParcelas', value: this.$t('plots'), isActive: true },
					{ key: 'tempoNaOS', value: this.$t('totalTime'), isActive: true },
					{
						key: 'mediaDeTempoEmCadaParcela',
						value: this.$t('averageTimePerPlot'),
						isActive: true,
					},
				]
			},
			set(e) {
				this.headersSelecionadosOS = e.map((m) => m.key)
			},
		},
		ordemServico() {
			console.log('this.nomeOs', this.crudTableOrdemServico)
			return this.crudTableOrdemServico
				.filter((m) => m.fk_fzda_fazenda == this.model.fzda_ds_descricao)
				.map((m) => {
					return {
						label: m['esfl_ds_descricao'],
						value: m['id'],
					}
				})
		},
		valoresNomeFazenda() {
			return this.fazenda.filter((m) => {
				return m['value'] == this.model.fzda_ds_descricao
			})
		},
		valoresTipoArvore() {
			return this.arrayTipoArv.map((m) => {
				console.log('valor de M', m)
				return {
					name: m[0],
					y: m[1],
				}
			})
		},
		valoresindicePerda() {
			return this.arrayindicePerda.map((m) => {
				console.log('valor de Mdsadsad', m)
				return {
					naoUteis: m[0],
					uteis: m[1],
					talhao: m[2],
				}
			})
		},
		valoresOrdemServico() {
			return (
				this.ordemServicoArray
					// .filter((n) => n.fk_fzda_fazenda == this.model.fzda_ds_descricao)
					.map((m) => {
						return {
							label: m['orsv_ds_descricao'],
							value: m['id'],
						}
					})
			)
		},

		arrayOrdemFiltrado() {
			return this.arrayOrdemServico
		},
		arrayrelatorioFiltrado() {
			return this.arrayRelatorioFiltro.filter((m) => m['id'] == this.model.ordemServicoId2)
		},
		valoresFustes() {
			return this.arrayFustes.map((m) => {
				console.log('valor de M', m)
				return {
					name: m[0],
					y: m[1],
				}
			})
		},
		/**
		 * Propriedade computada que serve para identificador para mostrar
		 * cards que estejam no Dashboard Geral
		 */
		isDashboardGeral() {
			return this.fazendaId === ''
		},
		/**
		 * Recupera o titulo do dashboard
		 * Visão geral para todas as fazendas
		 */
		tituloDashboard() {
			return this.nomeDaFazendaAtual === '' ? 'Visão Geral' : this.nomeDaFazendaAtual
		},
		/**
		 * Retorna a label contendo a data do ultimo processamento
		 */
		labelUltimoProcessamento() {
			if (!this.dataUltimoProcessamento) return ''
			else if (this.dataUltimoProcessamento.getYear() < 0) return 'não existem dados processados'
			return `último processamento em ${this.dataUltimoProcessamento.toLocaleDateString()} às ${this.dataUltimoProcessamento.toLocaleTimeString()}`
		},
	},

	components: {
		Button,
		ButtonDropdown,
		Pagination,
		ContentHeader,
		CrudTable,
		Card,
		SubHeader,
	},
	data() {
		return {
			text: [],
			contagemDeParcelas: 0,
			arrayReport: [],
			text2: [],
			showCrud: false,
			heading: 'RELATÓRIO DE RENDIMENTO OPERACIONAL',
			heading2: 'Produtividade',
			arrayteste: [],
			arrayteste2: [],
			arrayRelatorioFiltro: [],
			arrayMedicao: [],
			nomeOs: [],
			fazenda: [],
			inventariosArray: [],
			rerender: true,
			nomeFazenda: [],
			arrayFustes: [],
			boundsAllPoligonos: {},
			sourceCancelToken: {},
			newArrayNivel: [],
			arrayIMA: [],
			arrayTipoArv: [],
			arrayindicePerda: [],
			arrayCrudTableVTCC: [],
			arrayCrudTableVTSC: [],
			crudTableOrdemServico: [],
			ordemServicoArray: [],
			dataGraficoFazendaCategoriaDeArvores: [],
			dataGraficoArvoresUteis: {},
			dataGraficoArvoresUteisPorPlantio: [],
			dataGraficoMaterialGenetico: [],
			dataGraficoFaixaDeIdade: [],
			dataGraficoFazendas: [],
			dataCardMap: [],
			fazendas: [],
			fazendaId: '',
			kpis: undefined,
			mapInfoPoligonos: {},
			// Controle de exibicao dos graficos
			exibirKpis: true,
			exibirGraficoMaterialGenetico: true,
			exibirGraficoFaixaDeIdade: true,
			inventario: [],
			componentKey: 0,

			exibirGraficoFazendas: true,
			// Nome da Fazenda

			nomeDaFazendaAtual: '',
			// Informa a data do ultimo processamento
			dataUltimoProcessamento: undefined,
			headersSelecionados: [
				'fazenda',
				'orsv_ds_descricao',
				'orsv_dt_data_final',
				'orsv_dt_data_inicial',
				'orsv_dt_prazo_final',
				'estratoFlorestal',
			],
			headersSelecionadosOS: [
				'codigo',
				'mediaDeTempoEmCadaParcela',
				'tempoNaOS',
				'numeroDeParcelas',
				'funcao',
				'nome',
			],
			valueSelected: {
				menu: [
					{
						key: 'editar',
						value: 'Editar',
						isActive: false,
					},
					{ key: 'resumo', value: 'Resumo', isActive: false },
					{ key: 'dispersao', value: 'Visualizar Dispersão', isActive: false },
				],
			},
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'tlho_ds_descricao',
				titleCardPropertie: 'tlho_cd_codigo',
			},

			isLoading: false,
			estrato: '',
			mostraDados: false,
			arrayOrdemServico: [],
			arrayRelatorio: [],
			model: {
				fzda_ds_descricao2: '',
				fzda_ds_descricao: '',
				orsv_ds_descricao: '',
				orsv_dt_data_final: '',
				orsv_dt_data_inicial: '',
				estratoFlorestal: '',
				tipoDeServico: '',
				orsv_dt_prazo_final: '',

				fk_eicb_estrato_invcbg: '',
				ordemServicoId: 'c6d433b6-dbdb-4c54-874f-0333acd23ac6',
				ordemServicoId2: '',
			},
		}
	},
	methods: {
		forceRerender() {
			this.componentKey += 1
		},
		...mapActions('moduleImportShape', ['setAllShapes']),
		exportPDF() {
			this.arrayRelatorio.forEach((m) => {
				m.fazenda = this.valoresNomeFazenda[0]['label']
			})
			this.arrayRelatorioFiltro = this.arrayRelatorio

			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 429 ~ exportPDF ~ this.valoresNomeFazenda',
				this.valoresNomeFazenda[0]['label'],
			)
			this.arrayRelatorio.fazenda = this.fazenda.filter((m) => {
				m.value == this.fzda_ds_descricao
			})
			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 415 ~ exportPDF ~ this.arrayRelatorio',
				this.arrayRelatorio,
			)

			this.model.ordemServicoId = this.model.ordemServicoId2
			this.isLoading = true
			this.forceRerender()
			this.GetReportOrdemServico
			this.mostraDados = true
			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 332 ~ GetReportOrdemServico ~ this.model.ordemServicoId2',
				this.model.ordemServicoId2,
			)
			GetReportOrdemServico(this.model.ordemServicoId2).then((response) => {
				var { result: ordensReport } = response.data

				this.arrayOrdemServico = ordensReport
				console.log(
					'🚀 ~ file: OrdemDeServico.vue ~ line 459 ~ GetReportOrdemServico ~ this.arrayOrdemServico',
					this.arrayOrdemServico,
				)
				//  this.arrayordensReport = ordensReport

				if (this.arrayOrdemServico.length) {
					this.arrayOrdemServico.forEach((n) => {
						this.arrayteste2 = Object.values(n)
						this.arrayReport.unshift(this.arrayteste2)
					})
				}
				this.arrayReport.forEach((m) => {
					console.log('valor m 4', m[4])
					this.contagemDeParcelas += m[4]
				})
				console.log('this.contagemDeParcelas', this.contagemDeParcelas)
			})
			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 453 ~ exportPDF ~ arrayOrdemFiltrado',
				this.arrayteste2,
			)
			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 4533 ~ exportPDF ~ arrayOrdemFiltrado',
				this.arrayReport,
			)

			this.fzda_ds_descricao = ''
			this.ordemServico = []
		},

		//   html2canvas(document.querySelector("#canvas"), {
		//     imageTimeout: 5000,
		//     useCORS: true,
		//   }).then((canvas) => {
		//     let doc = new jsPDF({
		//       unit: "px",
		//       format: "tabloid",
		//       orientation: "l",
		//     });
		//     doc.addImage(canvas.toDataURL("image/png"), "JPEG", -120, 0);
		//     doc.addPage();
		//     doc.save("sample-file.pdf");
		//   });
		// },
		/**
		 * Seta o id da fazenda
		 */
		setFazendaId(fazendaId) {
			this.fazendaId = fazendaId
		},
		/**
		 * Seta os valores iniciais para cada mapInfo
		 */
		setInitialValueToMapInfo(mapInfos) {
			mapInfos.forEach((mapInfo) => {
				mapInfo.mapInfoPoligono = {}
				mapInfo.isActived = false
			})
			this.dataCardMap = mapInfos
		},

		/**
		 * Junta as informacoes de duas requisicoes diferentes
		 * Requisicao 1 = Informações da fazenda / estrato
		 * Requisicao 2 = Poligonos
		 */
		mergePoligonosToMapInfo() {
			if (this.dataCardMap.length > 0 && this.mapInfoPoligonos.poligonos) {
				const { poligonos, bounds } = this.mapInfoPoligonos

				this.dataCardMap.forEach((mapInfo) => {
					const mapInfoPoligono = poligonos.find(
						(mapInfoPoligono) => mapInfoPoligono.id === mapInfo.id,
					)
					if (mapInfoPoligono) {
						mapInfoPoligono.paths = CoordenatesToGooglePattern(
							mapInfoPoligono.poligono.coordinates,
							mapInfoPoligono.poligono.type,
						)
						mapInfo.mapInfoPoligono = mapInfoPoligono
					}
				})

				const [west, south, east, north] = bounds
				this.boundsAllPoligonos = { east, north, south, west }
			}
		},

		/**
		 * Seta os dados dos cards
		 */
		setDashboardInfoFazenda(dashboardInfoFazendas) {
			this.setInitialValueToMapInfo(dashboardInfoFazendas.cardMapInfos)
			this.mergePoligonosToMapInfo()
		},

		/**
		 * Troca o nome da fazenda atual, atualizando o titulo do dashboard
		 */
		trocarNomeDaFazenda(idDaFazenda) {
			if (idDaFazenda === '') this.nomeDaFazendaAtual = ''
			else {
				this.nomeDaFazendaAtual = this.fazendas.find(
					(fazenda) => fazenda.value === idDaFazenda,
				).label
			}
		},

		/**
		 * Retorna os dados de uma fazenda selecionar no dropdown de fazendas
		 */

		getDashboardFazenda(fazendaId) {
			this.$store.dispatch('moduleDashboardCardInfo/apiCardInfoFazenda', fazendaId)

			this.trocarNomeDaFazenda(fazendaId)

			getDataUltimoProcessamentoByFazendaId(fazendaId, this.sourceCancelToken.token).then(
				(response) => {
					this.dataUltimoProcessamento = new Date(response.data.result)
				},
			)

			getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoMaterialGenetico = response.data.result
			})

			getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoFaixaDeIdade = response.data.result
			})

			getQuantidadeDeArvoresPorCategoriaByFazendaId(fazendaId, this.sourceCancelToken.token).then(
				(response) => {
					this.dataGraficoFazendaCategoriaDeArvores = response.data.result
				},
			)

			getProporcaoDeArvoresUteisByFazendaId(fazendaId, this.sourceCancelToken.token).then(
				(response) => {
					this.dataGraficoArvoresUteis = response.data.result
				},
			)

			getProporcaoDeArvoresUteisGroupedByPlantioEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoArvoresUteisPorPlantio = response.data.result
			})
		},

		/**
		 * Faz as requisicoes necessarias para recuperar os dados de todas as fazendas
		 */
		getDashboardGeral() {
			this.$store.dispatch('moduleDashboardCardInfo/apiCardInfoGeral')

			this.trocarNomeDaFazenda('')
		},
	},
	watch: {
		/**
		 * Sempre que o valor de ID da fazenda alterar, deve trazer as informacoes
		 * relacionadas a fazenda selecionada
		 */
		arrayOrdemServico: function () {
			this.showCrud = true
			var len = 1
			const pdf = new jsPDF({
				orientation: 'portrait',
				unit: 'in',
				format: 'letter',
			})

			// var img = new Image();
			// img.src = "//i.imgur.com/QJ4AJXKb.jpg";

			// img.crossOrigin = ""; // for demo as we are at different origin than image

			const addHeader = (pdf) => {
				const pageCount = pdf.internal.getNumberOfPages()
				for (var i = 1; i <= pageCount; i++) {
					pdf.setPage(i)
					pdf.setFontSize(12).text(this.heading, 2.5, 1.0, { halign: 'center', maxWidth: 4.4 })
					pdf.setFontSize(12).text(this.heading2, 3.7, 1.3, { halign: 'center' })

					pdf.setLineWidth(0.01).line(0.5, 1.4, 8.0, 1.4)
					this.text = [
						`Fazenda: ${this.arrayrelatorioFiltrado[0].fazenda}`,
						`Ordem de Serviço: ${this.arrayrelatorioFiltrado[0].orsv_ds_descricao}`,
						`Data de Inicio e Fim: ${this.arrayrelatorioFiltrado[0].orsv_dt_data_inicial} à ${this.arrayrelatorioFiltrado[0].orsv_dt_data_final}`,
					]
					this.text2 = [
						`Estrato: ${this.arrayrelatorioFiltrado[0].estratoFlorestal}`,
						`Tipo de Ordem de Serviço: ${this.arrayrelatorioFiltrado[0].tipoDeServico}`,
						`Data Final: ${this.arrayrelatorioFiltrado[0].orsv_dt_prazo_final}`,
					]

					pdf.setFontSize(12).text(this.text, 0.5, 1.7, {
						align: 'left',
						maxWidth: 3.5,
					})
					pdf.setFontSize(12).text(this.text2, 8.0, 1.7, {
						align: 'right',
						maxWidth: 3.5,
					})
					pdf
						.setFontSize(12)
						.text(`Parcelas da Ordem de Serviço: ${this.contagemDeParcelas}`, 0.5, 2.9, {
							align: 'left',
							maxWidth: 3.5,
						})
					pdf
						.setFontSize(12)
						.text(
							`Coletores para a Ordem de Serviço: ${this.arrayrelatorioFiltrado[0].fk_exos.length}`,
							8.0,
							2.9,
							{
								align: 'right',
								maxWidth: 3.5,
							},
						)

					pdf.addImage(myImage, 'JPEG', 0.5, 0.5, 1.8, 0.6)
					pdf.addImage(myImage2, 'JPEG', 6.6, 0.01, 1.4, 1.3)
				}
			}

			// console.log("pageCount", pageCount);
			// if (pageCount == 1) {
			//   top = 1.2;
			// } else {
			//   top = 1.4;
			// }
			autoTable(pdf, {
				headStyles: { fillColor: 'rgb(149, 187, 73)' },
				alternateRowStyles: { fillColor: '#f2f2f2' },
				head: [
					[
						'Código',
						'Nome',
						'Função',
						'Total de Árvores',
						'Parcelas',
						'Tempo Total',
						'Tempo Médio por Parcela',
					],
				],
				body: this.arrayReport ? this.arrayReport : '',
				margin: { left: 0.6, top: 3.1 },
			})
			console.log('🚀 ~ file: OrdemDeServico.vue ~ line 682 ~ arrayteste2', this.arrayteste2)

			if (this.arrayOrdemServico.length || !this.arrayOrdemServico.length) {
				var myImage = new Image()
				var myImage2 = new Image()

				myImage.src = '//i.imgur.com/PrVU71S.jpeg'
				myImage2.src = '//i.imgur.com/yk44xUn.png'
				console.log('🚀 ~ file: OrdemDeServico.vue ~ line 731 ~ myImage', myImage)

				addHeader(pdf)

				pdf.save(`${this.heading}.pdf`)

				this.isLoading = false
			}
		},

		'model.fzda_ds_descricao': function (fazendaId) {
			console.log('fazendaId', fazendaId)
			this.arrayMedicao.forEach((m) => {
				if (m.fk_fzda_fazenda == fazendaId) {
					this.fazenda.fkOs = m.fk_orsv_ordem_servico
				}
			})
			console.log(
				'this.fazenda.fkMedicaothis.fazenda.fkMedicaothis.fazenda.fkMedicao',
				this.fazenda,
			)
			this.nomeOs = []

			this.ordemServicoArray
				.filter((m) => m.id == this.fazenda.fkOs)

				.forEach((ordemServico) => {
					this.nomeOs.unshift([ordemServico['orsv_ds_descricao'], ordemServico.id])
				})

			console.log('this.nomeInventariothis.nomeInventario', this.nomeOs)
		},
	},
	/**
	 * Carrega todos os dados relacionados as fazendas cadastradas
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	async created() {
		;(getAllMedicoesInventario().then((response) => {
			var { result: medicao } = response.data
			console.log(
				'🚀 ~ file: RelatorioInventarioFlorestal.vue ~ line 712 ~ getAllMedicoesInventario ~ medicao',
				medicao,
			)
			this.arrayMedicao = medicao
		}),
			(this.quantityPerPage = 10))
		this.sourceCancelToken = axios.CancelToken.source()

		GetReportOrdemServicoCabecalho().then((response) => {
			var { result: ordens } = response.data
			ordens.forEach((m) => {
				console.log('m.orsv_dt_data_final', m.orsv_dt_data_final)
				m.orsv_dt_data_final = new Date(m.orsv_dt_data_final).toLocaleDateString()
				m.orsv_dt_data_inicial = new Date(m.orsv_dt_data_inicial).toLocaleDateString()
				m.orsv_dt_prazo_final = new Date(m.orsv_dt_prazo_final).toLocaleDateString()
			})
			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 653 ~ GetReportOrdemServicoCabecalho ~ ordens',
				ordens,
			)

			this.arrayRelatorio = ordens
		})

		GetReportDropdownOrdemServico().then((response) => {
			var { result: ordens } = response.data
			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 706 ~ GetReportOrdemServico ~ ordens',
				ordens,
			)
			this.crudTableOrdemServico = ordens

			this.ordemServicoArray = ordens
			console.log(
				'🚀 ~ file: OrdemDeServico.vue ~ line 526 ~ GetReportDropdownOrdemServico ~ this.ordemServicoArray ',
				this.ordemServicoArray,
			)
		})
		// GetReportOrdemServico().then((response) => {
		//   var { result: ordensServico } = response.data;

		//   console.log(
		//     "🚀 ~ file: OrdemDeServico.vue ~ line 706 ~ GetReportOrdemServico ~ ordens",
		//     ordensServico
		//   );

		//   // ordensServico
		//   //   .filter(
		//   //     (m) =>
		//   //       m["fk_exos"][0]["fk_orsv_ordem_servico"] ==
		//   //       this.model.fk_orsv_ordem_servico
		//   //   )
		//   //   .forEach((n) => {
		//   //     console.log("VALOR DE N", n);
		//   //   });
		//   this.arrayRelatorio = ordensServico;
		// });

		getAllFazendasComInventarioFlorestalDropdown().then((response) => {
			const fazendas = response
			console.log(
				'🚀 ~ file: InventarioFlorestal.vue ~ line 187 ~ getDropdownFazendas ~ fazendas',
				fazendas,
			)

			fazendas.forEach((fazenda) => {
				this.nomeFazenda.unshift(fazenda.Nome)
			})

			this.fazenda = fazendas
			console.log(
				'🚀 ~ file: RelatorioInventarioFlorestal.vue ~ line 715 ~ getDropdownFazendas ~ this.fazenda',
				this.fazenda,
			)
		})
	},
}
</script>

<style scped>
.container__dashboard {
	width: 100%;
	height: 100%;
}

.container__dashboard__kpis {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	flex-wrap: wrap;
}

.container__dashboard__contentbody__card {
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.container__dashboard__contentbody__card > hr {
	margin: 0 1rem;
}

@media screen and (min-width: 992px) {
	.container__dashboard__contentbody__card {
		flex-direction: row;
	}

	.container__dashboard__contentbody__card > hr {
		height: auto;
		margin: 1rem 0;
		display: inline-block;
		width: 0.1px;
	}
}
</style>
